// extracted by mini-css-extract-plugin
module.exports = {"filtersBlock":"styles_filtersBlock__FKtTd","filters":"styles_filters__T_U0L"};